function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.042 37.968 33.712 37.968 24.88 17 16.025 37.968 19.696 37.968 13.731 50.425 22.586 50.425 22.586 56 27.174 56 27.174 50.425 36.006 50.425 30.042 37.968 30.042 37.968Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M85.795 22.784 88.383 22.784 82.155 8 75.912 22.784 78.5 22.784 74.294 31.568 80.538 31.568 80.538 35.498 83.773 35.498 83.773 31.568 90 31.568 85.795 22.784 85.795 22.784Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M54.855 29.619C59.048 32.457 70.263 37.896 72.162 39.248 74.818 41.138 83.446 45.393 76.808 56.905 70.17 68.417 64.022 76.9 59.952 83L5.006 83C18.668 71.785 39.7 62.531 48.791 55.973 57.882 49.415 58.375 44.461 54.006 39 50.006 34 46.418 32.591 44.948 29.58 42.331 24.222 51.782 21.954 55.006 22 55.397 22 59.006 22 59.006 22 59.006 22 50.661 26.782 54.855 29.619Z",
  fill: "currentColor"
});

var SvgRoad = function SvgRoad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "Icons_Road",
    overflow: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/road.bb1834e8.svg";
export { ForwardRef as ReactComponent };